<template>
  <div class="main">
    <div class="banner">
      <el-carousel height="550px" auto-play="4000" indicator-position="outside">
        <el-carousel-item v-for="banner in banners" :key="banner.index">
          <el-image :src="banner.url" mode="fit"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="block-full" style="background: #f0f5ff; padding: 40px 0 60px 0">
      <bigtitle title="成都欧米奇2026年报名"></bigtitle>
      <middletitle title="火热进行中"></middletitle>
      <apply></apply>
    </div>
    <div class="block-notfull" style="padding: 40px 0px 60px 0px">
      <bigtitle title="精品课程"></bigtitle>
      <middletitle title="2026年课程全面升级"></middletitle>
      <tab1></tab1>
    </div>
    <div
      class="block-full"
      style="background: #fafafa; padding: 40px 0px 60px 0px"
    >
      <bigtitle title="选择成都欧米奇的理由"></bigtitle>
      <middletitle title="REASONS FOR CHOOSING CHENGDU OMICK"></middletitle>
      <div style="width: 100%; height: 20px"></div>
      <el-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/class1.jpg"
      ></el-image>
      <div style="width: 100%; height: 20px"></div>
    </div>
    <div class="block-full" style="padding: 40px 0px 60px 0px">
      <bigtitle title="名师风采"></bigtitle>
      <middletitle title="精英名师亲授，助力你的成功事业路"></middletitle>
      <div style="width: 100%; height: 24px"></div>
      <el-carousel
        indicator-position="outside"
        type="card"
        loop
        :autoplay="false"
        style="width: 100%; margin: auto; height: 550px"
      >
        <el-carousel-item v-for="teacher in teachers" :key="teacher.index">
          <img :src="teacher.url" alt="" />
        </el-carousel-item>
      </el-carousel>
      <div style="width: 100%; height: 24px"></div>
      <buttongroup></buttongroup>
    </div>

    <div
      class="block-full"
      style="background: #f0f5ff; padding: 40px 0px 60px 0px"
    >
      <div class="block-notfull">
        <bigtitle title="校园环境"></bigtitle>
        <middletitle title="欧式风格，环境超赞！"></middletitle>
        <tab2></tab2>
        <div style="width: 100%; height: 15px"></div>
        <buttongroup></buttongroup>
      </div>
    </div>
    <div class="block-notfull" style="padding: 40px 0px 60px 0px">
      <bigtitle title="创就业帮扶"></bigtitle>
      <middletitle title="全国30余家家院校联动，全方位创就业扶持"></middletitle>
      <help></help>
      <buttongroup></buttongroup>
      <div style="width: 100%; height: 10px"></div>
    </div>
    <div
      class="block-full"
      style="background: #f0f5ff; padding: 40px 0px 60px 0px"
    >
      <div class="block-notfull">
        <bigtitle title="学员作品"></bigtitle>
        <middletitle title="你们的成长，烙印在每一个作品中"></middletitle>
        <tab4></tab4>
        <div style="width: 100%; height: 15px"></div>
        <buttongroup></buttongroup>
      </div>
    </div>
    <div class="block-notfull" style="padding: 40px 0px 60px 0px">
      <bigtitle title="推荐就业"></bigtitle>
      <middletitle title="校企合作，定向委托"></middletitle>
      <el-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/baking6/logo.jpg"
      ></el-image>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    bigtitle: () => import("@/components/common/bigTitle"),
    middletitle: () => import("@/components/common/middletitle"),
    tab1: () => import("@/components/common/tab1"),
    tab2: () => import("@/components/common/tab2"),
    tab4: () => import("@/components/common/tab4"),
    apply: () => import("@/components/common/apply"),
    help: () => import("@/components/common/help"),
    buttongroup: () => import("@/components/common/buttongroup"),
  },
   mounted() {
    window.scroll(0, 0);
  },
  data() {
    return {

      banners: [
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/banner/banner21.jpg",
          to: "",
        },
        
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/banner/banner6.jpg",
          to: "",
        }, 
       {
         url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/banner/banner2.jpg",
         to: "",
       },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/banner/banner3.jpg",
          to: "",
        },
       {
         url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/banner/banner4.jpg",
         to: "",
       },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/banner/banner5.jpg",
          to: "",
        },

      ],
      teachers: [
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t1.jpg",
          to: "",
        },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t2.jpg",
          to: "",
        },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t4.jpg",
          to: "",
        },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t5.jpg",
          to: "",
        },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t6.jpg",
          to: "",
        },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t7.jpg",
          to: "",
        },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t8.jpg",
          to: "",
        },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t9.jpg",
          to: "",
        },
        // {
        //   url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t10.jpg",
        //   to: "",
        // },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t11.jpg",
          to: "",
        },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t12.jpg",
          to: "",
        },
        // {
        //   url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t14.jpg",
        //   to: "",
        // },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t15.jpg",
          to: "",
        },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t16.jpg",
          to: "",
        },
        // {
        //   url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t17.jpg",
        //   to: "",
        // },
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/t18.jpg",
          to: "",
        },
      ]
    };
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-count-down {
  font-size: 32px;
  font-weight: 600;
  line-height: 60px;
  color: #fff;
}
/deep/ .van-button--normal {
  padding: 0;
}
/deep/ .van-notice-bar__left-icon,
.van-notice-bar__right-icon {
  color: red;
}
/deep/ .el-carousel__button {
  height: 5px;
}
/deep/ .el-carousel__indicators--outside button {
  background-color: #ff3d00;
}
/deep/ .el-carousel__container {
  height: 520px;
}

.van-swipe {
  cursor: auto;
}
.notice-swipe {
  height: 36px;
  line-height: 36px;
  font-size: 25px;
}
.van-notice-bar {
  color: #000;
  padding: 0 0 0 10px;
  background-color: #fff;
}
.van-swipe-item {
  text-align: center;
}
.b {
  color: red;
}

.md-card.md-with-hover {
  cursor: auto;
}
.banner {
  margin-top: 64px;
  background: #f0f5ff;
}
.block-notfull {
  width: 1200px;
  padding: 0 0 20px 0;
  margin: 0 auto;
}
.block-full {
  width: 100%;
  margin: 0 auto;
}
.card {
  width: 1200px;
  height: 760px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 0;
  position: relative;
}
.card-endtime {
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  position: absolute;
  color: #fff;
  bottom: 0;
  background: #ff3d00;
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
}
.card-hot-img {
  width: 590px;
  height: 328px;
  border-radius: 18px;
}
.help {
  width: 1200px;
  padding: 16px 0;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.help-one {
  width: 49.5%;
  height: 350px;
  border-radius: 18px;
  margin-bottom: 12px;
}
.help-one img {
  border-radius: 18px;
  width: 100%;
  height: 100%;
}
</style>